// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c3a71a48","2446":"31420fc2","2756":"31420fc2","5332":"31420fc2","6434":"31420fc2"}[chunkId] + ".chunk.css";
};